// src/admin/Orders.jsx
import { useState, useEffect } from "react";
import { getAllOrders } from "../services/orderService";
import { httpsCallable } from "firebase/functions";
import { functions } from "../services/firebase";

const deliverFn     = httpsCallable(functions, "deliverCredentials");
const resendEmailFn = httpsCallable(functions, "sendOrderEmail");

const S = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

/* ── Filter bar ── */
.ord-filter-bar {
  display:flex; gap:6px; flex-wrap:wrap; margin-bottom:16px;
  overflow-x:auto; padding-bottom:2px;
  -webkit-overflow-scrolling:touch;
}
.ord-filter-bar::-webkit-scrollbar { display:none; }
.ord-ftab {
  padding:6px 14px; border-radius:6px; font-size:11px; font-weight:700;
  cursor:pointer; transition:all 0.12s; border:1px solid;
  background:none; font-family:'Inter',sans-serif;
  letter-spacing:0.5px; text-transform:uppercase; white-space:nowrap; flex-shrink:0;
}

/* ── Order cards ── */
.ord-card {
  background:#1a1a1a; border:1px solid rgba(255,255,255,0.08);
  border-radius:10px; padding:14px 16px; margin-bottom:8px;
  transition:border-color 0.12s;
}
.ord-card:hover { border-color:rgba(255,255,255,0.14); }
.ord-card-top {
  display:flex; align-items:flex-start; gap:12px; margin-bottom:10px;
}
.ord-card-main { flex:1; min-width:0; }
.ord-card-right { display:flex; flex-direction:column; align-items:flex-end; gap:6px; flex-shrink:0; }
.ord-card-actions {
  display:flex; gap:8px; flex-wrap:wrap;
  padding-top:10px; border-top:1px solid rgba(255,255,255,0.05);
}
.status-pill {
  display:inline-block; padding:3px 10px; border-radius:4px;
  font-size:10px; font-weight:700; letter-spacing:0.5px;
}
.ord-act-btn {
  padding:6px 12px; border-radius:6px; font-size:11px; font-weight:600;
  cursor:pointer; transition:all 0.12s; border:1px solid;
  background:none; font-family:'Inter',sans-serif; white-space:nowrap;
}
.ord-act-btn:disabled { opacity:0.4; cursor:not-allowed; }
.ord-meta {
  font-size:11px; color:#6b6b6b;
  white-space:nowrap; overflow:hidden; text-overflow:ellipsis;
}

/* ── Deliver modal ── */
.modal-overlay {
  position:fixed; inset:0; background:rgba(0,0,0,0.75);
  display:flex; align-items:center; justify-content:center;
  z-index:1000; padding:20px;
}
.modal-box {
  background:#1a1a1a; border:1px solid rgba(0,120,242,0.25);
  border-radius:12px; padding:24px; width:100%; max-width:420px;
}
.modal-title { font-size:15px; font-weight:700; color:#fff; margin-bottom:6px; }
.modal-sub { font-size:12px; color:#6b6b6b; margin-bottom:18px; }
.modal-inp {
  width:100%; background:rgba(255,255,255,0.05);
  border:1px solid rgba(255,255,255,0.08); border-radius:6px;
  padding:10px 12px; color:#fff; font-family:'Inter',sans-serif;
  font-size:13px; outline:none; margin-bottom:10px; transition:border-color 0.15s;
}
.modal-inp:focus { border-color:rgba(0,120,242,0.4); }
.modal-btns { display:flex; gap:10px; margin-top:4px; }
.modal-deliver-btn {
  flex:1; padding:11px; background:#0078F2; border:none; border-radius:6px;
  color:#fff; font-family:'Inter',sans-serif; font-weight:700; font-size:13px; cursor:pointer;
  transition:all 0.15s;
}
.modal-deliver-btn:hover:not(:disabled) { background:#0a84ff; }
.modal-deliver-btn:disabled { opacity:0.4; cursor:not-allowed; }
.modal-cancel-btn {
  padding:11px 16px; background:rgba(255,255,255,0.06);
  border:1px solid rgba(255,255,255,0.1); border-radius:6px;
  color:#a3a3a3; font-family:'Inter',sans-serif; font-size:13px; cursor:pointer;
}

.skel { background:#222; border-radius:8px; animation:skPulse 1.5s ease infinite; }
@keyframes skPulse { 0%,100%{opacity:.5} 50%{opacity:1} }

/* ════════════════════
   MOBILE ≤ 768px
════════════════════ */
@media(max-width:768px) {
  .ord-card { padding:12px 14px; }
  .ord-card-actions { gap:6px; }
  .ord-act-btn { padding:7px 10px; font-size:10px; }
  .modal-box { padding:20px; }
}
`;

const STATUS_CFG = {
  delivered:     { label:"Delivered",   color:"#22c55e", bg:"rgba(34,197,94,0.1)",  border:"rgba(34,197,94,0.2)"  },
  paid:          { label:"Processing",  color:"#eab308", bg:"rgba(234,179,8,0.1)",  border:"rgba(234,179,8,0.2)"  },
  pending:       { label:"Pending",     color:"#0078F2", bg:"rgba(0,120,242,0.1)",  border:"rgba(0,120,242,0.2)"  },
  paid_no_stock: { label:"⚠️ No Stock", color:"#f97316", bg:"rgba(249,115,22,0.1)", border:"rgba(249,115,22,0.3)" },
  expired:       { label:"Expired",     color:"#6b6b6b", bg:"rgba(255,255,255,0.04)",border:"rgba(255,255,255,0.08)"},
  failed:        { label:"Failed",      color:"#ef4444", bg:"rgba(239,68,68,0.08)", border:"rgba(239,68,68,0.15)" },
};

function DeliverModal({ order, onClose, onDone }) {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [note,     setNote]     = useState("");
  const [saving,   setSaving]   = useState(false);

  async function handleDeliver(e) {
    e.preventDefault(); setSaving(true);
    try {
      await deliverFn({ orderId:order.id, steamEmail:email, steamPassword:password, steamNote:note });
      alert("✅ Credentials delivered!"); onDone();
    } catch (err) { alert("Error: " + err.message); }
    finally { setSaving(false); }
  }

  return (
    <div className="modal-overlay" onClick={e => e.target===e.currentTarget&&onClose()}>
      <div className="modal-box">
        <div className="modal-title">🔑 Manual Delivery</div>
        <div className="modal-sub">Order: {order.id?.slice(0,14)} · {order.gameTitle}</div>
        <form onSubmit={handleDeliver}>
          <input className="modal-inp" value={email}    onChange={e=>setEmail(e.target.value)}    placeholder="Steam Email *"    required />
          <input className="modal-inp" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Steam Password *" required />
          <input className="modal-inp" value={note}     onChange={e=>setNote(e.target.value)}     placeholder="Note (optional)" />
          <div className="modal-btns">
            <button type="submit" className="modal-deliver-btn" disabled={saving}>
              {saving ? "Delivering…" : "Deliver Now"}
            </button>
            <button type="button" className="modal-cancel-btn" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default function AdminOrders() {
  const [orders,       setOrders]       = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [filter,       setFilter]       = useState("all");
  const [deliverOrder, setDeliverOrder] = useState(null);
  const [resending,    setResending]    = useState("");

  const load = () => getAllOrders().then(o => { setOrders(o); setLoading(false); });
  useEffect(() => { load(); }, []);

  const filtered = filter === "all" ? orders : orders.filter(o => o.status === filter);

  async function handleResendEmail(orderId) {
    setResending(orderId);
    try { await resendEmailFn({ orderId }); alert("✅ Email resent!"); }
    catch (err) { alert("Failed: " + err.message); }
    finally { setResending(""); }
  }

  function fmtDate(ts) {
    if (!ts) return "—";
    const d = ts?.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-US", { day:"numeric", month:"short", year:"numeric" });
  }

  return (
    <>
      <style>{S}</style>
      {deliverOrder && (
        <DeliverModal
          order={deliverOrder}
          onClose={() => setDeliverOrder(null)}
          onDone={() => { setDeliverOrder(null); load(); }}
        />
      )}

      <div style={{ fontSize:16, fontWeight:800, color:"#fff", marginBottom:16 }}>📦 Orders</div>

      {/* Filter tabs — horizontally scrollable on mobile */}
      <div className="ord-filter-bar">
        {["all","pending","paid","paid_no_stock","delivered","expired","failed"].map(f => {
          const count = f === "all" ? orders.length : orders.filter(o => o.status === f).length;
          const cfg   = STATUS_CFG[f];
          const on    = filter === f;
          return (
            <button key={f} className="ord-ftab"
              style={{
                color:       on ? (cfg?.color || "#0078F2") : "#6b6b6b",
                borderColor: on ? (cfg?.border || "rgba(0,120,242,0.3)") : "rgba(255,255,255,0.08)",
                background:  on ? (cfg?.bg || "rgba(0,120,242,0.1)") : "none",
              }}
              onClick={() => setFilter(f)}
            >
              {f === "all" ? `All (${count})` : `${cfg?.label||f} (${count})`}
            </button>
          );
        })}
      </div>

      {loading ? (
        [...Array(4)].map((_,i) => <div key={i} className="skel" style={{ height:88, marginBottom:8 }} />)
      ) : filtered.length === 0 ? (
        <div style={{ textAlign:"center", padding:"60px 0", color:"#6b6b6b", fontSize:13 }}>
          No {filter === "all" ? "" : filter} orders
        </div>
      ) : filtered.map(order => {
        const cfg = STATUS_CFG[order.status] || STATUS_CFG.pending;
        return (
          <div key={order.id} className="ord-card">
            <div className="ord-card-top">
              <div className="ord-card-main">
                <div style={{ fontSize:14, fontWeight:700, color:"#fff", marginBottom:4 }}>
                  {order.gameTitle}
                </div>
                <div className="ord-meta">#{order.id?.slice(0,12)}</div>
                <div className="ord-meta">{order.userEmail}</div>
                <div className="ord-meta">{fmtDate(order.createdAt)}</div>
              </div>
              <div className="ord-card-right">
                <div style={{ fontSize:16, fontWeight:800, color:"#fff" }}>${order.amount?.toFixed(2)}</div>
                <span className="status-pill" style={{ background:cfg.bg, border:`1px solid ${cfg.border}`, color:cfg.color }}>
                  {cfg.label}
                </span>
              </div>
            </div>

            <div className="ord-card-actions">
              {(order.status === "paid_no_stock" || order.status === "paid") && (
                <button className="ord-act-btn"
                  style={{ color:"#0078F2", borderColor:"rgba(0,120,242,0.2)", background:"rgba(0,120,242,0.06)" }}
                  onClick={() => setDeliverOrder(order)}>
                  🔑 Manual Deliver
                </button>
              )}
              {order.status === "delivered" && (
                <button className="ord-act-btn"
                  style={{ color:"#22c55e", borderColor:"rgba(34,197,94,0.2)" }}
                  onClick={() => handleResendEmail(order.id)}
                  disabled={resending === order.id}>
                  {resending === order.id ? "Sending…" : "📧 Resend Email"}
                </button>
              )}
              <button className="ord-act-btn"
                style={{ color:"#6b6b6b", borderColor:"rgba(255,255,255,0.08)" }}
                onClick={() => alert(`Order ID: ${order.id}\nBakong Ref: ${order.khqrRef||"—"}\nPaid At: ${fmtDate(order.paidAt)}`)}>
                🔍 Details
              </button>
            </div>
          </div>
        );
      })}
    </>
  );
}